import React from 'react';
import { footerColumns } from '../data/navigation';
export function Footer() {
  return <footer className="bg-[#0A1F33] text-white/70 py-16 px-4 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-236" data-mp="3gfsmscqd8umz">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-[1.2fr_1.3fr_1.2fr_0.9fr_1fr_1fr] gap-12 lg:gap-8" data-id="element-237" data-mp="32oe11y52qfc8">
        <div className="sm:col-span-3 lg:col-span-1 lg:pr-8" data-id="element-238" data-mp="36pz9n7aks7gm">
          <img src="https://cdn.magicpatterns.com/uploads/vBy52qowPNFNY53vkUADE7/SyNeural-logo-no-tagline-half-size.svg" alt="SyNeural" className="h-10 w-auto mb-5 brightness-0 invert" data-id="element-239" data-mp="3ueih5klswg7n" />
          <p className="text-sm leading-relaxed" data-id="element-240" data-mp="3ldu4ouc22nwv">Building intelligence in the world.</p>
        </div>

        {footerColumns.map(column => <nav key={column.heading} aria-label={column.heading} data-id="element-241" data-mp="29z6x2jmuoxjl">
            <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm whitespace-nowrap" data-id="element-242" data-mp="29xvqyd5xndpb">
              {column.heading}
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-243" data-mp="3lalfndz543tf">
              {column.links.map(link => <li key={`${column.heading}-${link.label}`} className={link.deep ? 'pl-8 text-white/60' : link.nested ? 'pl-3' : ''} data-id="element-244" data-mp="3gb8s0r0g2sps">
                  <a href={link.href} className="hover:text-white transition-colors duration-150" data-id="element-245" data-mp="3q83pr7ow8p30">
                    {link.nested && <span aria-hidden="true" className="text-white/40 mr-2" data-id="element-246" data-mp="81ywqhwtbw3g">↳</span>}
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>)}
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/10 text-xs flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-247" data-mp="hs1wr22cqaba">
        <p data-id="element-248" data-mp="qt03hs46cvxk">&copy; {new Date().getFullYear()} SyNeural. All rights reserved.</p>
        <div className="flex gap-6" data-id="element-249" data-mp="mrwqdddihe01">
          <a href="/privacy" className="hover:text-white transition-colors duration-150" data-id="element-250" data-mp="msy1tiyfw2ia">
            Privacy Policy
          </a>
          <a href="/terms" className="hover:text-white transition-colors duration-150" data-id="element-251" data-mp="twxsxe84bibf">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}